import { useParams } from "react-router-dom";
import { useEmployeeInfo } from "../hooks/useEmployeeInfo";
import Loader from "../../../components/ui/Loader";
import CollapseSection from "../../../components/ui/CollapseSection";

export default function EmployeeDetails() {
  const { employeeId } = useParams<{ employeeId: string }>();
  const { data: employee, loading, error } = useEmployeeInfo(employeeId!);

  if (loading) return <Loader text="Loading employee details..." />;
  if (error) return <p>Error loading employee details: {error.message}</p>;
  if (!employee) return <p>No employee data found.</p>;

  return (
    <div style={{ padding: "2rem" }}>
      <h2>👤 {employee.name}</h2>
      <p><strong>Area:</strong> {employee.area ?? "N/A"}</p>
      <p><strong>Team Leader:</strong> {employee.teamLeaderName ?? "N/A"}</p>
      <p>
        <strong>Start Date:</strong>{" "}
        {employee.startDate
          ? new Date(employee.startDate).toLocaleDateString("pt-PT")
          : "N/A"}
      </p>
      <p>
        <strong>Evaluation Date:</strong>{" "}
        {employee.nextEvaluation
          ? new Date(employee.nextEvaluation).toLocaleDateString("pt-PT")
          : "N/A"}
      </p>
      <p><strong>Notes:</strong> {employee.note ?? "N/A"}</p>

      <CollapseSection title="📊 Previous Evaluations">
        {employee.completedEvaluations && employee.completedEvaluations.length > 0 ? (
          employee.completedEvaluations.map((ev, index) => (
            <div key={index} style={{ marginBottom: "1rem" }}>
              <p><strong>Name:</strong> {ev.evaluationName ?? "N/A"}</p>
              <p>
                <strong>Start Date:</strong>{" "}
                {ev.evaluationStartDate
                  ? new Date(ev.evaluationStartDate).toLocaleDateString("pt-PT")
                  : "N/A"}
              </p>
              <p><strong>Status:</strong> {ev.evaluationStatusLabel ?? "N/A"}</p>
              {index < employee.completedEvaluations!.length - 1 && <hr />}
            </div>
          ))
        ) : (
          <p>No completed evaluations found.</p>
        )}
      </CollapseSection>
    </div>
  );
}
